import * as R from "ramda";

import {
  generateItemsReducer,

  generateItemAndActionsFromStore,
  generateItemListAndActionsFromStore,
  generateStateActions,
} from "./item";

const itemType = "documentSetDocumentState";
const endpoint = "document_set_document_states/";

export const documentSetDocumentStatesReducer = generateItemsReducer<DocumentSetDocumentStateSnakeModel, {}>(itemType);

function documentSetDocumentStateMergeFunction(rawItem: ItemStateLoaded<DocumentSetDocumentStateSnakeModel, {}>) {
  return {
    ...rawItem.savedData,
    ...rawItem.editData,
    state: R.mergeDeepRight(rawItem.savedData.state, rawItem.editData?.state || {}),
  };
}

export const documentSetDocumentStateAndActionsFromStore = generateItemAndActionsFromStore<DocumentSetDocumentStateSnakeModel, {}, ItemStateActions>(
  itemType,
  endpoint,
  generateStateActions,
  documentSetDocumentStateMergeFunction,
);


export const documentSetDocumentStateListAndActionsFromStore = generateItemListAndActionsFromStore(itemType, documentSetDocumentStateAndActionsFromStore);
